import React, { useState } from "react";
import config from "lib/fr-config";
import ItemCategoryDropdownButtonView from "presentational/common/ItemCategoryDropdownButtonView";
import UsersItemUnitListView from "presentational/common/itemUnit/UsersItemUnitListView";
import ItemModalView from "presentational/common/modals/ItemModalView";
import MyItemListOptModalView from "presentational/portfolio/MyItemListOptModalView";
import CommonModalView from "presentational/common/modals/CommonModalView";
import PrivateMarkIconView from "presentational/common/PrivateMarkIconView";
import TextButtonView from "presentational/common/TextButtonView";
import TXT from "presentational/common/multinational/TXT";
import { getDeviceType } from "lib/deviceInfo";
import IconButtonView from "presentational/common/IconButtonView";
import PropTypes from "prop-types";

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const colorCss = config.css.color;
const MORE_BTN_TYPE = config.iconDesign.moreButton;

const cssXL = {
  topButtonLineWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop:
      desktopCss.paddingBetweenTextButton -
      desktopCss.standardPaddingBetweenContent,
    marginBottom: desktopCss.standardPaddingBetweenContent
  },
  privateIconWrapper: { display: "flex", flexDirection: "row", marginRight: 6 },
  dropdownWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  },
  itemDeleteModeBtnWrapper: {
    marginBottom: desktopCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "flex-end"
  }
};

const cssXS = {
  topButtonLineWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop:
      mobileCss.paddingBetweenTextButton -
      mobileCss.standardPaddingBetweenContent,
    marginBottom: mobileCss.standardPaddingBetweenContent
  },
  privateIconWrapper: { display: "flex", flexDirection: "row", marginRight: 6 },
  dropdownWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  },
  itemDeleteModeBtnWrapper: {
    marginBottom: mobileCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "flex-end"
  }
};

MyItemListView.propTypes = {
  preset: PropTypes.shape({
    isItemListPublic: PropTypes.bool
  }).isRequired,
  catListOfMine: PropTypes.array,
  selectedCategory: PropTypes.string,
  itemList: PropTypes.array.isRequired,
  isItemListLoading: PropTypes.bool.isRequired,
  isItemListEnd: PropTypes.bool.isRequired,
  itemDeleteMode: PropTypes.bool.isRequired,
  onItemDeleteModeChange: PropTypes.func.isRequired,
  onDropdownSelect: PropTypes.func.isRequired,
  onNextItemListRequest: PropTypes.func.isRequired,
  onItemDeleteSubmit: PropTypes.func.isRequired,
  onItemUploadClick: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired
};

function MyItemListView(props) {
  const {
    preset,
    catListOfMine,
    selectedCategory,
    itemList,
    isItemListLoading,
    isItemListEnd,
    itemDeleteMode,
    onItemDeleteModeChange,
    onDropdownSelect,
    onNextItemListRequest,
    onItemDeleteSubmit,
    onItemUploadClick,
    onItemClick
  } = props;
  const [itemModalOpen, setItemModalOpen] = useState(false);
  const [selectedItemInfo, setSelectedItemInfo] = useState(null);
  const [optionModalOpen, setOptionModalOpen] = useState(false);
  const [itemDeleteModalOpen, setItemDeleteModalOpen] = useState(false);
  const [removableItemInfo, setRemovableItemInfo] = useState(null);

  const deviceType = getDeviceType();
  const css = deviceType === "mobile" ? cssXS : cssXL;

  const handleItemClick = selectedItemInfo => {
    if (itemDeleteMode) {
      setSelectedItemInfo(selectedItemInfo);
      setItemModalOpen(true);
    } else {
      onItemClick(selectedItemInfo);
    }
  };

  const handleModalClose = () => {
    setItemModalOpen(false);
    setOptionModalOpen(false);
    setItemDeleteModalOpen(false);
  };

  const handleOptBtnClick = () => {
    setOptionModalOpen(true);
  };

  const handleDeleteSelect = () => {
    onItemDeleteModeChange({ itemDeleteMode: true });
  };

  const handleItemDeleteClick = itemInfo => {
    setItemModalOpen(false);
    setItemDeleteModalOpen(true);
    setRemovableItemInfo(itemInfo);
  };

  const handleItemDeleteSubmit = async () => {
    const { itemHash } = removableItemInfo;
    setItemDeleteModalOpen(false);
    setRemovableItemInfo(null);
    await onItemDeleteSubmit(itemHash);
  };

  const handleEscapeDelModeBtnClick = () => {
    onItemDeleteModeChange({ itemDeleteMode: false });
  };

  return (
    <div>
      <div style={css.topButtonLineWrapper}>
        <div style={css.privateIconWrapper}>
          <PrivateMarkIconView
            isItemListPublic={preset.isItemListPublic}
            displayPrivateOnly
            removeBorder
          />
        </div>
        <div style={css.dropdownWrapper}>
          {catListOfMine && selectedCategory && (
            <ItemCategoryDropdownButtonView
              dropdownName={"category"}
              categoryList={catListOfMine}
              selectedItem={selectedCategory}
              onSelect={onDropdownSelect}
            />
          )}
          <IconButtonView
            type={MORE_BTN_TYPE}
            disableRightMargin
            onClick={handleOptBtnClick}
            buttonSize={"small"}
            fontSize={"small"}
          />
          <MyItemListOptModalView
            open={optionModalOpen}
            onClose={handleModalClose}
            onDeleteSelect={handleDeleteSelect}
            onItemUploadClick={onItemUploadClick}
          />
        </div>
      </div>
      {itemDeleteMode && (
        <div style={css.itemDeleteModeBtnWrapper}>
          <TextButtonView
            onClick={handleEscapeDelModeBtnClick}
            fontColor={colorCss.colorOfDanger}
            disableRightMargin
          >
            <TXT name="btnExitItemDeleteMode" />
          </TextButtonView>
        </div>
      )}
      <UsersItemUnitListView
        itemList={itemList}
        isItemListLoading={isItemListLoading}
        isItemListEnd={isItemListEnd}
        onItemClick={handleItemClick}
        onNextItemListRequest={onNextItemListRequest}
        deleteMode={itemDeleteMode}
        emptyListText={<TXT name="msg_emptyListMyItem" />}
      />
      {selectedItemInfo && (
        <ItemModalView
          open={itemModalOpen}
          itemInfo={selectedItemInfo}
          onClose={handleModalClose}
          deleteMode={itemDeleteMode}
          displayDetailTooltip={!itemDeleteMode}
          onDelete={handleItemDeleteClick}
        />
      )}
      <CommonModalView
        open={itemDeleteModalOpen}
        onClose={handleModalClose}
        titleText={<TXT name="titleModal_deleteItem" />}
        contentText={<TXT name="msg_deleteItem" />}
        firstButtonText={<TXT name="btnModal_cancel" />}
        firstButtonFunc={handleModalClose}
        secondButtonText={<TXT name="btnModal_delete" />}
        secondButtonTextColor={colorCss.colorOfDanger}
        secondButtonFunc={handleItemDeleteSubmit}
      />
    </div>
  );
}

export default MyItemListView;
